import { Point2D } from '@trimble/utilities';
import type { ProjectGeoReference } from './project-geo-reference';

/**
 * Scene CRS for the 2D basemap:
 * 1. Active point-cloud CSIB + center while a cloud is loaded
 * 2. Project geo when no point cloud is loaded
 * 3. Last loaded point-cloud geo
 */
export function pickEffectiveGeoReference(
  activePcCsib: string | undefined,
  activePcCenter: Point2D | undefined,
  projectGeo: ProjectGeoReference | undefined,
  lastPcGeo: ProjectGeoReference | undefined
): ProjectGeoReference | undefined {
  if (activePcCsib !== undefined && activePcCenter !== undefined) {
    return { csib: activePcCsib, center: activePcCenter };
  }

  if (projectGeo !== undefined) {
    return projectGeo;
  }

  return lastPcGeo;
}

/**
 * First inserted cloud that has both a CSIB and a center.
 * Pair by item id so a cloud with only a center cannot steal another cloud's CRS.
 */
export function pickFirstLoadedPcGeo(
  loadedCsibs: ReadonlyMap<string, string>,
  loadedCenters: ReadonlyMap<string, Point2D>
): { csib: string; center: Point2D } | undefined {
  for (const [itemId, csib] of loadedCsibs) {
    const center = loadedCenters.get(itemId);
    if (center !== undefined) {
      return { csib, center };
    }
  }
  return undefined;
}
